<template>
  <div class="card shadow p-3">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">{{ title }} {{ $t("in") }} {{ $t("inventory") }}</h3>
        </div>
        <div class="col text-right">
          <b-button
            @click="
              $router.push({
                name: 'create_inventory',
                params: {
                  id: item.id,
                  type: 2,
                  company: item.company.id,
                },
              })
            "
            size="sm"
            variant="outline-primary"
            >{{ $t("add") }}</b-button
          >
          <b-button
            v-b-tooltip.hover
            :title="$t('history')"
            variant="primary"
            size="sm"
            ><i class="fas fa-history"></i
          ></b-button>
        </div>
      </div>
    </div>

    <b-row>
      <b-col md="2">
        <b-form-select
          v-model="perPage"
          :options="[5, 10, 20, 100]"
          @input="changePerPage"
          size="sm"
          class="mt-2"
        ></b-form-select>
      </b-col>
      <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
        <b-form-group>
          <b-input-group>
            <b-form-input
              class="form-control-sm"
              v-model="searchData"
              type="search"
              :placeholder="$t('search')"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="12" class="table-responsive">
        <b-table
          class="align-items-center table-flush tablesorter table-text"
          hover
          :items="warehouses"
          :fields="columns"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="warehouses.length > 0 ? false : true"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <span class="h2 text-danger">{{ $t("fail") }}</span>
            </div>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
              v-b-tooltip.hover
              :title="$t('add_quantity')"
              variant="warning"
              size="sm"
              @click="$refs.create.showModal({type: 1, res: data.item})"
              ><i class="fas fa-plus"></i
            ></b-button>
            <b-button
              v-b-tooltip.hover
              :title="$t('subtract_quantity')"
              variant="warning"
              size="sm"
              @click="$refs.create.showModal({type: 0, res: data.item})"
              ><i class="fas fa-minus"></i
            ></b-button>
          </template>
        </b-table>
        <h4 class="text-right mr-4">
          {{ $t("quantity_total") }}: {{vmData.total_quantity}}
        </h4>
       <!--  <b-pagination
          v-if="
            !Array.isArray(warehouses.data) ||
            warehouses.data.length === 0
              ? false
              : true
          "
          class="mt-3"
          v-model="warehouses.current_page"
          :total-rows="warehouses.total"
          :per-page="warehouses.per_page"
          :page-count="warehouses.per_page"
          @input="changePage"
          first-number
          pills
          size="sm"
          align="center"
        ></b-pagination> -->
      </b-col>
       <modal-create ref="create" />
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ModalCreate from "../Inventory/addOrSubtrac.vue";

import _ from "lodash";
export default {
  name: "inventory-table",
  props: {
    title: String,
    item: {
      type: Object,
      default: () => {},
    },
  },
   components: {
    ModalCreate,
  },
  async created() {
    await this.getDataWarehouse({
      currentPage: 1,
      perPage: this.perPage,
      product: this.$route.params.id,
    });
    this.debouncedGetAnswer = _.debounce(this.search, 500);
  },
  watch: {
    searchData: function (newQuestion, oldQuestion) {
      this.debouncedGetAnswer();
    }
  },
  data() {
    return {
      perPage: 5,
      currentPage: 1,
      searchData: "",
    };
  },
  methods: {
    ...mapActions({
      addInventary: "inventory/addInventary",
      subtractInventary: "inventory/subtractInventary",
      getDataWarehouse: "inventory/getWarehouseByProduct",
    }),
    async search() {
      await this.getDataWarehouse({
        currentPage: this.currentPage,
        perPage: this.perPage,
        search: this.searchData,
        product: this.$route.params.id,
      });
    },
    async changePage(value) {
      await this.getDataWarehouse({
        currentPage: value ? value : 1,
        perPage: this.perPage,
        product: this.$route.params.id,
      });
    },
    async changePerPage() {
      await this.getDataWarehouse({
        currentPage: this.currentPage,
        perPage: this.perPage,
        product: this.$route.params.id,
      });
    },
  },
  computed: {
    ...mapGetters({
      warehouses : "inventory/getWarehouseByProduct",
      vmData : 'inventory/getInventoryProduct'
    }),
    columns() {
      return [
        { label: this.$t("name"), key: "warehouse.name", class: "text-center" },
        {
          label: this.$t("address"),
          key: "warehouse.address",
          class: "text-center",
        },
        {
          label: this.$t("city"),
          key: "warehouse.city.name",
          class: "text-center",
        },
        {
          label: this.$t("quantity"),
          key: "quantity",
          class: "text-center",
        },
        { label: this.$t("actions"), key: "actions", class: "text-center" },
      ];
    }
  }
};
</script>